import { getToken } from "../../authorization/auth";
import { API_ENDPOINT } from "../../authorization/const";

export async function getAllCashNote() {
    const res = await fetch(API_ENDPOINT + "transaction/cash-note/get-all/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function cashNotePayment(note) {
    const data = { "auth": getToken(), "note": note };
    const res = await fetch(API_ENDPOINT + "transaction/ledger-post-cash-note", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function newCashNote(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "transaction/cash-note/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
